import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {VmoProductModal} from 'vmo-library'

import {productSubscribe, productSubscribeDetails, productVerifyToken} from 'actions'
import {PRODUCT_SUBSCRIBE, PRODUCT_SUBSCRIBE_DETAILS, PRODUCT_VERIFY_TOKEN} from 'actions/types'
import {get, getService} from 'utils/helper'
import {getRoleInfo} from 'utils/local-storage'

const ShowProductModal = ({productModal, setShowProductModal}) => {
  const dispatch = useDispatch()
  const userRole = getRoleInfo()?.role || ''

  const [singleProductModal, setSingleProductModal] = useState(false)

  const {successLabels = [], type = []} = useSelector(state => state.apiReducer)
  const {
    productSubDetails = [],
    tokenData = {},
    productSubData: {login = {}} = {},
  } = useSelector(state => state.appReducer)

  useEffect(() => {
    dispatch(productSubscribeDetails())
  }, [dispatch])

  useEffect(() => {
    if (successLabels.includes(PRODUCT_VERIFY_TOKEN)) {
      const domain = get(['accountInfo', 'domain'], JSON.parse(window.localStorage.getItem('support')))
      const url = `https://${domain}.${process.env.REACT_APP_DOMAIN}/${getService(tokenData?.service)}/home`
      const newValue = {veemoToken: tokenData?.token}

      window.localStorage.setItem(getService(tokenData?.service), JSON.stringify(newValue))
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }, [successLabels, tokenData])

  useEffect(() => {
    if (successLabels.includes(PRODUCT_SUBSCRIBE)) {
      window.localStorage.setItem(getService(login?.service), JSON.stringify({veemoToken: login?.token}))
      window.open(login?.domainURL, '_blank', 'noopener,noreferrer')
      setSingleProductModal(false)
      dispatch(productSubscribeDetails())
    }
  }, [successLabels, login, setSingleProductModal, dispatch])

  return (
    <VmoProductModal
      productModal={productModal}
      setShowProductModal={setShowProductModal}
      isProductLoading={type.includes(PRODUCT_SUBSCRIBE_DETAILS)}
      accountProductDetails={productSubDetails}
      productName="desk"
      handleOpenDashBoard={service => dispatch(productVerifyToken(service))}
      isOpenDashBoardLoading={type.includes(PRODUCT_VERIFY_TOKEN)}
      singleProductModal={singleProductModal}
      setSingleProductModal={setSingleProductModal}
      userRole={userRole}
      handleProductSubscribe={service => dispatch(productSubscribe(service))}
      isStartFreeTrailLoading={type.includes(PRODUCT_SUBSCRIBE)}
    />
  )
}

export default ShowProductModal
